// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------

import styled from 'styled-components';

export const BulletContainer = styled.div`
  margin-top: 1.5625rem;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`;
